import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { NewCustomTablePageDocument } from 'generated/resources/graphql'

import Loading from 'modules/core/components/Loading'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import resources from 'modules/custom_resources/store/collections/customResources/resources'
import FormModal from 'modules/employees/components/CustomTables/FormModal'
import { RouteContext } from 'modules/employees/pages/CustomTablesListPage/context'

export default function NewCustomTablePage() {
  const navigate = useNavigate()

  const { id: employeeIdparam, schemaId } = useStrictParams<'id' | 'schemaId'>()
  const { employee: sessionEmployee } = useCurrentSession()

  const employeeId = employeeIdparam ? Number(employeeIdparam) : sessionEmployee.id

  const rootRoute = React.useContext(RouteContext)

  const { data, loading } = useQuery(NewCustomTablePageDocument, {
    variables: {
      employeeId: employeeId,
      schemaId: Number(schemaId),
    },
    skip: !schemaId,
  })

  const schema = data?.customResources.schema
  const currency = data?.employees.employee?.legalEntity?.currency ?? ''
  const canRemoveCustomTableRecords =
    data?.employees?._policies?.removeCustomTableRecords?.can ?? false

  const resource = resources.find({
    schema_id: schema?.id,
    attachable_type: 'Employee',
    attachable_id: employeeId,
  })

  const onClose = () => {
    !!rootRoute && navigate(rootRoute.customTablesIndex())
  }

  if (loading) {
    return <Loading />
  }

  if (!schema) return null

  return (
    <FormModal
      schema={schema}
      resource={resource}
      attachableId={employeeId}
      attachableType="Employee"
      currency={currency}
      canRemoveCustomTableRecords={canRemoveCustomTableRecords}
      onClose={onClose}
    />
  )
}
